import styled from 'styled-components';

import { HexColorBar } from '@dreryk/react-components';

export const StyledHexColorBar = styled(HexColorBar)`
   position: absolute;
   left: 0;
   top: 0;
   bottom: 0;
`;

StyledHexColorBar.displayName = 'StyledHexColorBar';
